"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowsStyled = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
const shouldForwardProp = prop => {
  switch (prop) {
    // Add any props here that should not be forwarded to the underlying DOM element.
    case "color":
      return false;
    default:
      return true;
  }
};
const ArrowsStyled = (0, _styled.default)("svg", {
  shouldForwardProp
})`
    position: absolute;
    color: ${_ref => {
  let {
    color
  } = _ref;
  return color;
}};
`;
exports.ArrowsStyled = ArrowsStyled;
//# sourceMappingURL=ArrowsStyled.js.map